import { createContext } from 'react';

const RouteDataLoaderContext = createContext();

export default RouteDataLoaderContext;
